var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 27.5V24.375L12.5 21.75V17.25L2.5 21.25V17.5L12.5 10.5V5C12.5 4.3125 12.745 3.72417 13.235 3.235C13.725 2.74584 14.3133 2.50084 15 2.5C15.6867 2.49917 16.2754 2.74417 16.7662 3.235C17.2571 3.72584 17.5017 4.31417 17.5 5V10.5L27.5 17.5V21.25L17.5 17.25V21.75L21.25 24.375V27.5L15 25.625L8.75 27.5Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsFlight);
export default __webpack_public_path__ + "static/media/material-symbols_flight.0d8f29af251bf81f706d0ec105e6a67f.svg";
export { ForwardRef as ReactComponent };